export enum BondStatusEnum {
    Active = 'Active',
    Canceled = 'Canceled',
    Expired = 'Expired',
    Expiring = 'Expiring',
    Pending = 'Pending'
}
